import { useQuery } from "@apollo/client";
import { getFragmentData, graphql } from "gql/apollo";
import { darkWebPostFieldsFragmentDoc } from "gql/apollo/graphql";

export const GetDarkWebPost = graphql(/* GraphQL */ `
	query GetDarkWebPost($params: GetDarkWebPostParams!) {
		getDarkWebPost(params: $params) {
			...darkWebPostFields
		}
	}
`);

export const useGetDarkWebPost = (postId: string, skip = false) => {
	const { data, loading, error } = useQuery(GetDarkWebPost, {
		variables: {
			params: {
				_id: postId,
			},
		},
		skip,
	});

	return {
		darkWebPost: getFragmentData(
			darkWebPostFieldsFragmentDoc,
			data?.getDarkWebPost
		),
		loading,
		error,
	};
};
